/**
 * Drop effect to apply when moving an item
 */
export const ITEM_DROP_EFFECT = 'move';

/**
 * Drop effect to apply when dropping file
 */
export const FILE_DROP_EFFECT = 'link';
